import { Component } from "@angular/core"
import { AlertController, ViewController, LoadingController, NavParams } from "ionic-angular"

import firebase from "firebase"

import { AppUtils } from "../../services/app-utils"

@Component({
  selector: "profile-data-page",
  templateUrl: "data.html",
})
export class ProfileDataPage {

  user: any = {}

  constructor(
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private navParams: NavParams
  ) {

    this.user = this.navParams.get("user")

    if (!this.user.social)
      this.user.social = { facebook: "", twitter: "", linkedin: "" }
  }

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onUpdate() {

    if (!this.validData())
      return

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    this.user.social.linkedin = this.clearSocialData(this.user.social.linkedin)
    this.user.social.facebook = this.clearSocialData(this.user.social.facebook)
    this.user.social.twitter = this.clearSocialData(this.user.social.twitter)

    firebase.database().ref(`users/${this.user.uid}`).set(this.user)
      .then(() => {

        loading.dismiss()
        this.viewCtrl.dismiss(this.user)
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          title: "Falha ao atualizar seus dados",
          message: "Por favor tente novamente em alguns minutos",
          buttons: ["Ok"]
        }).present()
      })
  }

  validData() {

    let message = ""
    let isOk = true

    if (!this.user.firstName || !this.user.lastName) {
      message = "Por favor informe seu nome e sobrenome"
    } else if (!this.user.occupation || !this.user.ddd || !this.user.phone) {
      message = "Por favor informe seus dados profissionais"
    } else if (!this.validSocialData()) {
      message = "Por favor informe apenas seu nome de usuário nas redes sociais"
    }

    if (message) {
      isOk = false
      this.alertCtrl.create({
        message,
        buttons: ["Ok"]
      }).present()
    }

    return isOk
  }

  validSocialData() {

    return !this.isSocialUrl(this.user.social.linkedin) &&
           !this.isSocialUrl(this.user.social.facebook) &&
           !this.isSocialUrl(this.user.social.twitter)
  }

  isSocialUrl(value) {

    if (!value)
      return false

    return (value.indexOf("http") > -1 || value.indexOf(".com") > -1)
  }

  clearSocialData(value) {

    value = AppUtils.replaceAll(value, "/", "")
    value = AppUtils.replaceAll(value, "@", "")

    return value
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/data.ts